import {
  CLEAR_ADMIN_ORG_USERS,
  CLEAR_ADMIN_ORG_USERS_FILTER,
  CLEAR_MAGIC_LOGIN,
  CLEAR_USER_NOTIFICATION,
  DELETE_ADMIN_ORG_USER_FAILURE,
  DELETE_ADMIN_ORG_USER_SUCCESS,
  FETCH_ADMIN_ORG_USERS_BEGIN,
  FETCH_ADMIN_ORG_USERS_FAILURE,
  FETCH_ADMIN_ORG_USERS_SUCCESS,
  GET_ADMIN_ORG_USER_BY_ID_BEGIN,
  GET_ADMIN_ORG_USER_BY_ID_FAILURE,
  GET_ADMIN_ORG_USER_BY_ID_SUCCESS,
  MAGIC_LOGIN_BEGIN,
  MAGIC_LOGIN_FAILURE,
  MAGIC_LOGIN_NEW_SUCCESS,
  MAGIC_LOGIN_SUCCESS,
  SET_ADMIN_ORG_USERS_FILTER,
  UPDATE_ADMIN_ORG_USER_FAILURE,
  UPDATE_ADMIN_ORG_USER_SUCCESS,
  UPDATE_ADMIN_ORG_USERS_BEGIN,
} from 'actions/admin/OrgUsersActions';

const initialState = {
  orgUsers: [],
  loading: false,
  error: null,
  notification: null,
  dummyData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  pagination: {},
  orgUserDetail: {},
  formSuccess: false,
  activeFilter: {
    page: 1,
    per_page: 25,
    organisation_id: null,
    active: null,
  },
  magicUrl: null,
  magicLoading: null,
};

export default function adminOrgUsersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADMIN_ORG_USERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        notification: null,
      };
    case FETCH_ADMIN_ORG_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orgUsers: action.data.users,
        pagination: action.data.pagination,
        filters: action.data.filters,
      };
    case FETCH_ADMIN_ORG_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        orgUsers: [],
      };
    case GET_ADMIN_ORG_USER_BY_ID_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        magicUrl: null,
        notification: null,
      };

    case GET_ADMIN_ORG_USER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        orgUserDetail: action.data,
      };

    case GET_ADMIN_ORG_USER_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case UPDATE_ADMIN_ORG_USERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        magicUrl: null,
        notification: null,
      };
    case UPDATE_ADMIN_ORG_USER_SUCCESS:

      return {
        ...state,
        loading: false,
        formSuccess: true,
        orgUserDetail: action.data,
      };
    case UPDATE_ADMIN_ORG_USER_FAILURE:
      return {
        ...state,
        loading: false,
        formSuccess: false,
        error: action.payload.error,
      };
    case MAGIC_LOGIN_BEGIN:
      return {
        ...state,
        magicUrl: null,
        magicLoading: true,
        notification: null,
      };
    case MAGIC_LOGIN_SUCCESS:
      return {
        ...state,
        magicLoading: false,
        magicUrl: action.data.magic_login_url,
      };
    case MAGIC_LOGIN_NEW_SUCCESS:
      return {
        ...state,
        magicLoading: false,
        magicUrlNew: action.data.magic_login_url,
      };
    case MAGIC_LOGIN_FAILURE:
      return {
        ...state,
        magicUrl: null,
        magicLoading: false,
        error: action.payload.error,
      };
    case CLEAR_MAGIC_LOGIN:
      return {
        ...state,
        magicUrl: null,
      };
    case DELETE_ADMIN_ORG_USER_SUCCESS:
      return {
        ...state,
        formSuccess: true,
        loading: false,
        notification: action.msg,
      };
    case DELETE_ADMIN_ORG_USER_FAILURE:
      return {
        ...state,
        loading: false,
        formSuccess: false,
        error: action.payload.error,
      };
    case CLEAR_ADMIN_ORG_USERS:
      return {
        ...initialState,
      };
    case SET_ADMIN_ORG_USERS_FILTER:
      return {
        ...state,
        activeFilter: { ...state.activeFilter, ...action.payload.filters },
      };
    case CLEAR_ADMIN_ORG_USERS_FILTER:
      return {
        ...state,
        activeFilter: initialState.activeFilter,
      };
    case CLEAR_USER_NOTIFICATION:
      return {
        ...state,
        error: null,
        notification: null,
      };
    default:
      return state;
  }
}
